// extracted by mini-css-extract-plugin
export var description = "styles-module--description--fff31";
export var descriptionContainer = "styles-module--descriptionContainer--00da1";
export var layout = "styles-module--layout--0937b";
export var subtitle = "styles-module--subtitle--6dac7";